export default class LPV2MainProductStateManager {
	constructor() {
		if (!window.LPV2MainProductState) {
			window.LPV2MainProductState = {
				selectedVariantId: null,
				selectedColor: null,
				selectedPlan: null,
				quantity: 1,
				stockStatus: 'in_stock',
				// ...other state as needed
			};
		} else {
		}
		this.state = window.LPV2MainProductState;
	}

	getState() {
		return { ...this.state };
	}

	setState(newState) {
		// Get caller information

		const stack = new Error().stack;
		const callerLine = stack.split('\n')[2] || 'unknown';
		const match = callerLine.match(/at\s+(.+?)\s+\((.+?):(\d+):(\d+)\)/);
		const filename = match ? match[2].split('/').pop() : 'unknown';
		
		//console.log(`setState() - call - ${filename}`);

		const previousSelectedVariantId = this.state.selectedVariantId;
		const previousSelectedVariant =this.state.selectedVariant?  JSON.stringify(this.state.selectedVariant) :"";
		
		
		this.state = { ...this.state, ...newState };
		this.recalculate();		
		window.LPV2MainProductState = this.state;
		document.dispatchEvent(new CustomEvent('lpv2-state-changed', { detail: this.getState() }));		


		const selectedVariantId = this.state.selectedVariantId;
		const selectedVariant =this.state.selectedVariant?  JSON.stringify(this.state.selectedVariant) :"";

		if (selectedVariantId !== previousSelectedVariantId || selectedVariant !== previousSelectedVariant) {
			document.dispatchEvent(new CustomEvent('variantChanged', { detail: this.getState().selectedVariant }));
		}
	}

	recalculate() {
		const variant = this.state.selectedVariant;
		let plan = null;
		
		// First try to find plan by selectedPlanId
		if (this.state.selectedPlanId && this.state.sellingPlanGroups) {
			for (const group of this.state.sellingPlanGroups) {
				const found = (group.selling_plans || []).find(p => p.id == this.state.selectedPlanId);
				if (found) { 
					plan = found; 
					break; 
				}
			}
		}
		
		// Fallback to sellingPlanIndex if no plan found by ID
		if (!plan && this.state.sellingPlanGroups && this.state.sellingPlanIndex !== undefined) {
			const group = this.state.sellingPlanGroups[this.state.sellingPlanIndex];
			if (group && group.selling_plans && group.selling_plans[this.state.sellingPlanIndex]) {
				plan = group.selling_plans[this.state.sellingPlanIndex];
			}
		}
		
		// Final fallback to first available plan
		if (!plan && this.state.sellingPlanGroups && this.state.sellingPlanGroups.length > 0) {
			const firstGroup = this.state.sellingPlanGroups[0];
			if (firstGroup && firstGroup.selling_plans && firstGroup.selling_plans.length > 0) {
				plan = firstGroup.selling_plans[0];
			}
		}

		// Check variant allocations if still no plan found
		if (!plan && this.state.selectedPlanId && variant && Array.isArray(variant.selling_plan_allocations)) {
			const foundSpa = variant.selling_plan_allocations.find(spa => {
				const id = spa.selling_plan_id || (spa.selling_plan && spa.selling_plan.id);
				return String(id) === String(this.state.selectedPlanId);
			});
			if (foundSpa) {
				plan = foundSpa.selling_plan || { id: this.state.selectedPlanId };
			}
		}

		if (!plan && this.state.selectedPlan && String(this.state.selectedPlan.id) === String(this.state.selectedPlanId)) {
			plan = this.state.selectedPlan;
		}

		if (!plan && this.state.selectedPlanId) {
			plan = { id: this.state.selectedPlanId };
		}
		
		this.state.selectedPlan = plan;
		const selectedPlanType = this.state.purchaseOption || 'subscription';
		const selectedFreebies = this.state.selectedFreebies || [];
		const freebies = this.state.freebies || [];

		// Check if freebies are enabled in theme customizer
		const enableFreebiesSwiper = window.LPV2MainProductInitialState?.enableFreebiesSwiper;
		const freebiesEnabled = enableFreebiesSwiper !== false && enableFreebiesSwiper !== "false";

		// Clear selectedFreebies if freebies are disabled
		const effectiveSelectedFreebies = freebiesEnabled ? selectedFreebies : [];

		let prices;

		if (selectedPlanType === 'onetime') {
			// Onetime: use variant price and compare_at_price (fallback to baseCompareAtPrice from initial state)
			const price = variant ? variant.price : (this.state.baseDiscountedPrice || 0);
			let compareAt = (variant && typeof variant.compare_at_price === 'number' && variant.compare_at_price > price)
				? variant.compare_at_price
				: (typeof this.state.baseCompareAtPrice === 'number' && this.state.baseCompareAtPrice > price ? this.state.baseCompareAtPrice : null);
			const savings = (typeof compareAt === 'number' && compareAt > price) ? (compareAt - price) : 0;
			prices = {
				discountedPrice: price,
				compareAtPrice: compareAt,
				savings: savings,
				recurringPrice: null,
				planDiscount: 0
			};
		} else {
			// Subscription: use full SKIO logic
			prices = this.calculateSkioPrices({
				variant,
				plan,
				selectedFreebies: effectiveSelectedFreebies,
				freebies
			});
		}
		this.state = { ...this.state, ...prices };
	}

	setVariant(variant) {
		this.setState({
			selectedVariant: variant,
			selectedVariantId: variant.id,
			stockStatus: variant.available ? 'in_stock' : 'out_of_stock',
		});
	}

	getVariant() {
		return this.state.selectedVariant;
	}

	// --- NEW: Calculate SKIO prices (discounted, recurring, savings, etc.) ---
	calculateSkioPrices({ variant, plan, selectedFreebies, freebies }) {
		if (!variant) return {};
		// 1. Base compare_at_price
		let compareAtPrice = (variant.compare_at_price && variant.compare_at_price > variant.price)
			? variant.compare_at_price
			: (typeof this.state.baseCompareAtPrice === 'number' && this.state.baseCompareAtPrice > variant.price ? this.state.baseCompareAtPrice : null);
		// 2. Add selected freebies' compare_at_price (only if setting is not enabled)
		const removeFreebies = window.LPV2MainProductInitialState?.removeFreebiesFromOriginalPrice;
		if (!removeFreebies && Array.isArray(selectedFreebies) && Array.isArray(freebies)) {
			selectedFreebies.forEach(freebieId => {
				const freebie = freebies.find(f => String(f.id) === String(freebieId));
				if (freebie && (freebie.compare_at_price || freebie.price)) {
					const freebieCompare = freebie.compare_at_price || freebie.price;
					compareAtPrice = (compareAtPrice || variant.price) + freebieCompare;
				}
			});
		}
		let discountedPrice = variant.price;
		let recurringPrice = null;
		let planDiscount = 0;
		let discountAmount = 0;
		
		if (plan && Array.isArray(plan.price_adjustments) && plan.price_adjustments.length > 0) {
			// Look through price adjustments for first-order discounts and recurring prices
			let foundFirstOrderDiscount = false;
			
			plan.price_adjustments.forEach(adj => {
				// Handle percentage discounts (usually for first order)
				if (adj.value_type === 'percentage' && adj.order_count === 1 && !foundFirstOrderDiscount) {
					planDiscount = adj.value;
					discountAmount = Math.round(variant.price * (planDiscount / 100));
					discountedPrice = variant.price - discountAmount;
					foundFirstOrderDiscount = true;
				}
				// Handle percentage discounts without order_count (only if no explicit first-order discount found)
				else if (adj.value_type === 'percentage' && !adj.order_count && !foundFirstOrderDiscount) {
					planDiscount = adj.value;
					discountAmount = Math.round(variant.price * (planDiscount / 100));
					discountedPrice = variant.price - discountAmount;
					foundFirstOrderDiscount = true;
				}
				// Handle fixed_amount discounts
				else if (adj.value_type === 'fixed_amount' && (adj.order_count === 1 || !adj.order_count) && !foundFirstOrderDiscount) {
					discountAmount = adj.value;
					discountedPrice = variant.price - discountAmount;
					planDiscount = Math.round((discountAmount / variant.price) * 100);
					foundFirstOrderDiscount = true;
				}
				// Handle price type for FIRST ORDER (sets a fixed price, not a discount)
				else if (adj.value_type === 'price' && adj.order_count === 1 && !foundFirstOrderDiscount) {
					discountedPrice = adj.value;
					discountAmount = variant.price - adj.value;
					planDiscount = Math.round((discountAmount / variant.price) * 100);
					foundFirstOrderDiscount = true;
				}
				// Handle price type for RECURRING orders (order_count null, 2, or higher)
				else if (adj.value_type === 'price' && (!adj.order_count || adj.order_count >= 2)) {
					recurringPrice = adj.value;
				}
			});
		}
		
		if (variant && Array.isArray(variant.selling_plan_allocations)) {
			const matchingSpa = variant.selling_plan_allocations.find(a => (a.selling_plan_id || a.selling_plan?.id) === plan?.id);
			if (matchingSpa && typeof matchingSpa.recurring_price === 'number' && matchingSpa.recurring_price > 0) {
				recurringPrice = matchingSpa.recurring_price;
			}
		}
		
		if (!recurringPrice) recurringPrice = discountedPrice;
		return {
			discountedPrice,
			compareAtPrice,
			recurringPrice,
			planDiscount,
			savings: compareAtPrice - discountedPrice
		};
	}

	// ...add more as needed
} 